import { combineReducers } from 'redux'
import { reducer as addNombreCentre } from './addNombreCentrePrivee'
import { reducer as editNombreCentre } from './editNombreCentrePrive'
import { reducer as deleteNombreCentre } from './deleteNombreCentrePrive'
import { reducer as getAllPrivateCenters } from './getAllPrivateCenters'

export default combineReducers({
    addNombreCentre,
    editNombreCentre,
    deleteNombreCentre,
    getAllPrivateCenters,
})
